import React, { useState } from "react";
import { images } from "../assets/styles/Images";

/**
 * Renders a remote icon from the API `icon_url`. Falls back to a generic
 * placeholder when the URL is empty, a dummy/non-resolving URL (e.g. the
 * `dummy.edufeel.local` URLs used in dev), or fails to load. No code change is
 * needed once real icon URLs ship — the same <img> will simply resolve.
 */
const RemoteIcon = ({ src, alt = "icon", className = "h-10 w-10", fallback = images.iconPlaceholder }) => {
  const [failed, setFailed] = useState(false);

  const resolvedSrc = !src || failed ? fallback : src;

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
    />
  );
};

export default RemoteIcon;
